import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useState } from 'react';
import { FormValidationError } from '../../../models';
import { EFormNavigationDirections } from '../../../constants';
import { StepTransitionToken } from './utils/stepTransitionToken';
import { EStepTransitionStatus, EStepUnreachableErrorPolicy, useStepWizard } from '../../../packages/StepWizard';
import { prepareFormStepValues } from '../../helpers';
export var useSteps = function useSteps(props) {
  var stepsSchema = props.stepsSchema,
    skipSteps = props.skipSteps,
    onSubmit = props.onSubmit,
    onNextStep = props.onNextStep,
    onPrevStep = props.onPrevStep,
    initialFormValue = props.initialFormValue,
    firstStepCode = props.firstStepCode,
    initialStepCode = props.initialStepCode;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    stepError = _useState2[0],
    setStepError = _useState2[1];
  var _useState3 = useState(props.initialFormValue),
    _useState4 = _slicedToArray(_useState3, 2),
    prevFormValue = _useState4[0],
    setPrevFormValue = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    lastNavDirection = _useState6[0],
    setLastNavDirection = _useState6[1];
  var _useStepWizard = useStepWizard({
      scheme: stepsSchema,
      firstStepCode: firstStepCode,
      config: {
        onStepUnreachable: EStepUnreachableErrorPolicy.MoveFirst
      },
      initialParams: {
        skipSteps: skipSteps,
        answers: initialFormValue,
        stepCode: initialStepCode
      }
    }),
    stepsHistory = _useStepWizard.stepsHistory,
    _useStepWizard$progre = _useStepWizard.progress,
    currentStepCount = _useStepWizard$progre.currentStepCount,
    maxStepsCount = _useStepWizard$progre.maxStepsCount,
    currentStep = _useStepWizard.currentStep,
    _nextStep = _useStepWizard.nextStep,
    _prevStep = _useStepWizard.prevStep;
  var resetError = function resetError() {
    return setStepError('');
  };
  var handleError = function handleError(error, formikHelpers) {
    if (error instanceof FormValidationError) {
      formikHelpers.setErrors(error.errors);
      return;
    }
    setStepError(error instanceof Error ? error.message : error);
  };

  /**
   * Если коллбэк onSubmit вернул новое значение формы - сбрасываем форму к этому значению, иначе сбрасываем к текущему значению формы.
   */
  var handleSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var callbackProps, formikHelpers, values, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            callbackProps = _ref.callbackProps, formikHelpers = _ref.formikHelpers;
            values = callbackProps.formValue;
            _context.next = 4;
            return onSubmit(callbackProps);
          case 4:
            result = _context.sent;
            if (result) {
              values = result;
            }
            formikHelpers.resetForm({
              values: values
            });
            setPrevFormValue(values);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onSubmit]);

  /**
   * Если коллбэк onNextStep/onPrevStep вернул новое значение формы - сбрасываем форму к этому значению, иначе сбрасываем к текущему значению формы.
   * В коллбэк onNextStep/onPrevStep передается управляющий токен, с помощь которого можно отменить запущенный переход между шагами.
   */
  var handleStepTransition = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var callbackProps, direction, formikHelpers, navigate, values, token, changeStepCallback, result, formValues;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            callbackProps = _ref3.callbackProps, direction = _ref3.direction, formikHelpers = _ref3.formikHelpers, navigate = _ref3.navigate;
            values = callbackProps.formValue;
            token = new StepTransitionToken();
            changeStepCallback = direction === EFormNavigationDirections.Forward ? onNextStep : onPrevStep;
            if (!changeStepCallback) {
              _context2.next = 9;
              break;
            }
            _context2.next = 7;
            return changeStepCallback(callbackProps, token);
          case 7:
            result = _context2.sent;
            if (result) {
              values = result;
            }
          case 9:
            formValues = prepareFormStepValues(callbackProps.stepsHistory[callbackProps.stepsHistory.length - 1].question.fields, values);
            formikHelpers.resetForm({
              values: formValues
            });
            if (token.allowTransition) {
              setPrevFormValue(values);
              setLastNavDirection(direction);
              navigate();
            }
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [onNextStep, onPrevStep]);

  /**
   * Внутренний обработчик перехода на следующий шаг или сабмит формы.
   * Если не находит по схеме следующий шаг - вызывает onCrackedNextStepCond.
   * Если вызван и шаг не последний - вызвает обработчик перехода.
   * Если вызван на последнем шаге - вызвает обработчик сабмита.
   * Если в обработчике перехода/сабмита возникает ошибка - прокидывает ошибку в обработчик ошибок.
   */
  var setNextStep = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formValue, formikHelpers) {
      var stepTransition;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            resetError();
            stepTransition = _nextStep({
              skipSteps: skipSteps,
              answers: formValue
            });
            if (!(stepTransition.status === EStepTransitionStatus.Error)) {
              _context3.next = 5;
              break;
            }
            if (props.onCrackedNextStepCond) {
              props.onCrackedNextStepCond(currentStep, stepTransition.error);
            }
            return _context3.abrupt("return");
          case 5:
            _context3.prev = 5;
            if (!(stepTransition.status === EStepTransitionStatus.Ready)) {
              _context3.next = 10;
              break;
            }
            _context3.next = 9;
            return handleStepTransition({
              callbackProps: {
                formValue: formValue,
                prevFormValue: prevFormValue,
                fromStep: currentStep,
                stepsHistory: stepTransition.history
              },
              direction: EFormNavigationDirections.Forward,
              formikHelpers: formikHelpers,
              navigate: stepTransition.navigate
            });
          case 9:
            return _context3.abrupt("return");
          case 10:
            _context3.next = 12;
            return handleSubmit({
              callbackProps: {
                formValue: formValue,
                prevFormValue: prevFormValue,
                stepsHistory: stepTransition.history,
                fromStep: currentStep
              },
              formikHelpers: formikHelpers
            });
          case 12:
            _context3.next = 17;
            break;
          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](5);
            handleError(_context3.t0, formikHelpers);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 14]]);
    }));
    return function setNextStep(_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();

  /**
   * Внутренний обработчик перехода на предыдущий шаг.
   * Если вызван на первом шаге - ничего не делает.
   * Если вызван и шаг не первый - вызвает обработчик перехода.
   * Если в обработчике перехода возникает ошибка - прокидывает ошибку в обработчик ошибок.
   */
  var setPrevStep = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(formikContext) {
      var stepTransition, formValue;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            stepTransition = _prevStep();
            if (!(stepTransition.status === EStepTransitionStatus.Error)) {
              _context4.next = 4;
              break;
            }
            if (props.onCrackedNextStepCond) {
              props.onCrackedNextStepCond(currentStep, stepTransition.error);
            }
            return _context4.abrupt("return");
          case 4:
            if (!(stepTransition.status === EStepTransitionStatus.Boundary)) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return");
          case 6:
            formValue = _objectSpread({}, formikContext.values);
            resetError();
            _context4.prev = 8;
            _context4.next = 11;
            return handleStepTransition({
              callbackProps: {
                formValue: formValue,
                prevFormValue: prevFormValue,
                stepsHistory: stepTransition.history,
                fromStep: currentStep
              },
              direction: EFormNavigationDirections.Backward,
              formikHelpers: formikContext,
              navigate: stepTransition.navigate
            });
          case 11:
            _context4.next = 16;
            break;
          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](8);
            handleError(_context4.t0, formikContext);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[8, 13]]);
    }));
    return function setPrevStep(_x5) {
      return _ref6.apply(this, arguments);
    };
  }();
  return {
    setNextStep: setNextStep,
    setPrevStep: setPrevStep,
    currentStep: currentStep,
    currentStepCount: currentStepCount,
    maxStepsCount: maxStepsCount,
    stepError: stepError,
    resetError: resetError,
    isFirstStep: stepsHistory.length === 1,
    lastNavDirection: lastNavDirection
  };
};